import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Input,
  OnInit,
  Optional,
} from '@angular/core';
import { Router } from '@angular/router';
import { RoutePath } from '@univacity/shared/types';
import { AngularUiModule } from '@univacity/angular/ui';
import { MessageThread } from '@univacity/shared/types';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { Observable } from 'rxjs';
import { MessagesFacade } from '../../../+state/messages/messages.facade';
import { MessageThreadCoverComponent } from '../message-thread-cover/message-thread-cover.component';

@Component({
  selector: 'un-message-thread-card',
  imports: [
    CommonModule,
    NzBadgeModule,
    AngularUiModule,
    MessageThreadCoverComponent,
  ],
  templateUrl: './message-thread-card.component.html',
  styleUrls: ['./message-thread-card.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageThreadCardComponent implements OnInit {
  @Input() thread: MessageThread;
  cleanText?: string;
  count$: Observable<number>;
  constructor(
    private router: Router,
    public facade: MessagesFacade,
    @Optional() private drawer?: NzDrawerRef
  ) {}

  ngOnInit(): void {
    this.cleanText = this.thread.lastMessage?.text.replace(
      /<\/?[^>]+(>|$)/g,
      ''
    );
    this.facade.fetchThreadUnread(this.thread._id);
  }

  @HostListener('click', ['$event.target']) onClick() {
    this.router.navigate([RoutePath.dashboardMessages], {
      queryParams: {
        thread: this.thread._id,
      },
      queryParamsHandling: 'merge',
    });
    // this.facade.fetchMessages(this.thread._id);
    if (this.drawer) this.drawer.close();
  }
}
